// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-nocheck
/* eslint-disable jsx-a11y/anchor-is-valid */
import React, { useEffect, useMemo, useState } from "react";
import { Stack, useMediaQuery, useTheme } from "@mui/material";
import {
  GridActionsCellItem,
  GridPaginationModel,
  GridColDef,
  GridRowId,
} from "@mui/x-data-grid";
import { DeleteConfirmModal, Table } from "../../molecules";
import { IDefinitionChangeParam, useAuthorization,DeleteDefinitionChangeParamRequest, useGetDefinitionChangeParamsList, useDeleteDefinitionChangeParam} from "../../../hooks";
import { Loading } from "../../atoms";
import { useSetSnackBar } from "../../../store/Snackbar.state";
import { downloadExcel } from "../../../util/downloadExcel";

export type ConfirmationListingTableProps = {
  onRowClick?: (data: { id: GridRowId; row: IDefinitionChangeParam }) => void;
  isModalClosed?: boolean;
};

export const ConfirmationListingTable = ({
  onRowClick,
  isModalClosed,
}: ConfirmationListingTableProps) => {
  const theme = useTheme();
  const {showDelete, showUpdate} = useAuthorization();
  const isDesktop = useMediaQuery(theme.breakpoints.up("md"));
  const [queryOptions, setQueryOptions] = React.useState({});
  const [paginationModel, setPaginationModel] = React.useState({
    page: 0,
    pageSize: 25,
  });
  const { data: getData, mutate: getDefinitionChangeParamsList, isLoading } = useGetDefinitionChangeParamsList();
  const [isDeleteModalOpen, setIsDeleteModalOpen] = useState(false);
  const [selectedRowId, setSelectedRowId] = useState(0);
  const setSnackbar = useSetSnackBar();
  // const tableData = getData?.data;
  const [tableData, setTableData] = useState<PagingResponse<Array<any>>>();
  const { mutate: parameterDelete, isLoading: isDeleteLoading } = useDeleteDefinitionChangeParam();
  const [shouldRefresh, setShouldRefresh] = React.useState(false);

  
  useEffect(() => {
    if (!isModalClosed) {
    const requestPayload = {
      size: paginationModel.pageSize,
      page: paginationModel.page,
      orderBy: "CreateDate",
      orderByDesc: true,
      ...getQueryParams(queryOptions),
    };
    if (queryOptions?.field && queryOptions?.value !== undefined) {
      requestPayload[queryOptions.field] = queryOptions.value;
    }

    getDefinitionChangeParamsList(
requestPayload,
      {
        onSuccess: (data) => {
          if (data.isSuccess) {
            setTableData(data?.data);
          } else {
            setTableData(data?.data);
            setSnackbar({
              severity: "error",
              description: data.message,
              isOpen: true,
            });
          }
        },
        onError: () => {
          setSnackbar({
            severity: "error",
            description: "İşlem sırasında bir hata oluştu",
            isOpen: true,
          });
        },
      });
  }}, [
    getDefinitionChangeParamsList,
    paginationModel.page,
    paginationModel.pageSize,
    setSnackbar,
    queryOptions,
    shouldRefresh,
    isModalClosed
  ]);

  const handleChangePagination = (model: GridPaginationModel) => {
    setPaginationModel(model);
    setTableData(undefined);
    getDefinitionChangeParamsList(
      {
        size: paginationModel.pageSize,
        page: paginationModel.page,
        orderBy: "CreateDate",
        orderByDesc: true,
      },
      {
        onSuccess: (data) => {
          if (data.isSuccess) {
            setTableData(data?.data);
          } else {
            setSnackbar({
              severity: "error",
              description: data.message,
              isOpen: true,
            });
          }
        },
        onError: () => {
          setSnackbar({
            severity: "error",
            description: "İşlem sırasında bir hata oluştu",
            isOpen: true,
          });
        },
      }
    );
  };

  const deleteRow = React.useCallback(
    (role: any) => () => {
      setIsDeleteModalOpen(true);
      setSelectedRowId(Number(role.id));
    },
    []
  );

  const handleCloseDeleteModal = () => {
    setIsDeleteModalOpen(false);
  };

  const handleDeleteConfirm = () => {
    const deleteRequest: DeleteDefinitionChangeParamRequest = { id: selectedRowId };

    parameterDelete(deleteRequest, {
      onSuccess: (data: any) => {
        if (data.isSuccess) {
          setShouldRefresh(prevState => !prevState);
          setSnackbar({
            severity: "success",
            isOpen: true,
            description: data.message,
          });
        } else {
          setSnackbar({
            severity: "error",
            description: data.message,
            isOpen: true,
          });
        }
      },
      onError: () => {
        setSnackbar({
          severity: "error",
          description: "İşlem sırasında bir hata oluştu",
          isOpen: true,
        });
      },
    });

    handleCloseDeleteModal();
  };
  const columns: GridColDef[] = useMemo(() => {
    return [
      {
        field: "Aksiyonlar",
        type: "actions",
        width: 80,
        getActions: (params) => [
          !!showDelete ? <GridActionsCellItem
            label="Sil"
            onClick={deleteRow(params.row)}
            showInMenu
          /> : <></>,
        ],
      },
      { field: "id", headerName: "İşlem ID", width:200 },
      { field: "processGroup", headerName: "İşlem Grubu", width:250 },
      { field: "processType", headerName: "İşlem Tipi", width:200 },
      { field: "roleLevel", headerName: "Rol Seviyesi", width:200 },
    ];
  }, [deleteRow, showDelete]);

  const onSave = () => {
    const requestPayload = {
      size: -1,
        page: 0,
        orderBy: "CreateDate",
        orderByDesc: true,
        ...getQueryParams(queryOptions),
    };

    if (queryOptions?.field && queryOptions?.value !== undefined) {
      requestPayload[queryOptions.field] = queryOptions.value;
    }

    getDefinitionChangeParamsList(
    requestPayload,
      {
        onSuccess: (data) => {
          if (data.isSuccess) {
            function fieldValue(data) {
              return data.map((item) => {
                return {
                  "İşlem ID": item?.id,
                  "İşlem Grubu": item?.processGroup,
                  "İşlem Tipi": item?.processType,
                  "Rol Seviyesi": item?.roleLevel,
                };
              });
            }
            const refactoredData = fieldValue(data?.data?.result );
            downloadExcel(refactoredData || [], "Onay Parametreleri Listesi");
          } else {
            setSnackbar({
              severity: "error",
              description: data.message,
              isOpen: true,
            });
          }
        },
        onError: () => {
          setSnackbar({
            severity: "error",
            description: "İşlem sırasında bir hata oluştu",
            isOpen: true,
          });
        },
      }
    );
  };

  const debounce = (func, delay) => {
    let timeoutId;
    return (...args) => {
      clearTimeout(timeoutId);
      timeoutId = setTimeout(() => {
        func.apply(null, args);
      }, delay);
    };
  };

  const getQueryParams = (filters) => {
    const queryParams = {};

    for (let key in filters) {
      if (filters[key]?.toString()?.length >= 1) {
        queryParams[key] = filters[key];
      }
    }

    return queryParams;
  };
  const handleFilterChange = debounce((filters) => {
    if (filters.clearFilter) {
      return setQueryOptions({});
    }
  
    const queryParams = getQueryParams(filters);
  
    const allValuesAtLeastThreeChars = Object.values(queryParams).every((value) => value?.toString().length >= 3);
    const atLeastOneValueThreeChars = Object.values(queryParams).some((value) => value?.toString().length >= 3);
    
    const previousKeysLength = Object.keys(previousQueryParams.current).length;
    const currentKeysLength = Object.keys(queryParams).length;
  
    // Eğer queryParams bir önceki ile aynıysa işlem yapma
    if (JSON.stringify(previousQueryParams.current) === JSON.stringify(queryParams)) {
      return;
    }
  
    if ((allValuesAtLeastThreeChars || (atLeastOneValueThreeChars && previousKeysLength > currentKeysLength))) {
      setQueryOptions(queryParams);
    }
  
    // Son olarak, mevcut queryParams değerini bir önceki değer olarak set edin
    previousQueryParams.current = queryParams;
  
  }, 500);
  const hasActiveFilters = Object?.keys(queryOptions)?.length > 0;
  // Komponent içerisinde
  const previousQueryParams = React.useRef({});
  const hasLoading = isLoading || isDeleteLoading;
  return (
    <>
      {hasLoading && <Loading />}
      <Stack flex={1} p={2}>
   
          <>
            <Table
             columnVisibilityConfigKey="confirmationListingColumnVisibilityKey"
              handleFilterChange={handleFilterChange}
              paginationModel={paginationModel}
              hasActiveFilters={hasActiveFilters}
              onPaginationModelChange={handleChangePagination}
              paginationMode="server"
              rowCount={tableData?.totalItems || 0}
              sx={{ width: isDesktop ? 1308 : window.innerWidth - 50 }}
              isRowSelectable={() => false}
              // disableColumnMenu
              onRowClick={!!showUpdate ? onRowClick : () => null}
              rows={tableData?.result || []}
              columns={columns}
              exportFileName="Onay Parametreleri  Listesi"
              onSave={() => onSave()}
            />
            <DeleteConfirmModal
              isOpen={isDeleteModalOpen}
              onClose={handleCloseDeleteModal}
              onConfirm={() => handleDeleteConfirm()}
            ></DeleteConfirmModal>
          </>
      
      </Stack>
    </>
  );
};
